import {useEffect} from 'react'

export default function PlayerVerticalContainer(props) {
  const {
    handleContinueWatching,
    navigate,
    nextEpisodeVisibility,
    setNextEpisodeVisibility,
    nextVod,
    isVertical
  } = props

  useEffect(() => {
    if (nextEpisodeVisibility) {
      setNextEpisodeVisibility(false)
      handleContinueWatching()
      navigate(`/player/shorts/${nextVod._id}`, {replace: true})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextEpisodeVisibility])

  return (
    <>
      <main className='appWrap'>
        <div className={isVertical ? 'playerWrapper vPlayerWrapper' : 'playerWrapper'}>
          <div id="mdstrm"></div>
        </div>
      </main>
    </>
  )
}